import { getInstance } from "../../core/axios-gateway";

const BASE_PATH = "/api/users";

export const authenticateUser = async (data: {
  role?: string;
  supplierId: string;
  email?: string;
  phone?: string;
}) => {
  return getInstance()
    .post<any>(`${BASE_PATH}/auth`, data)
    .then((res) => res.data);
};
